import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import type { SiteSettings } from '@/lib/types';

export function useSiteSettings() {
  const [data, setData] = useState<SiteSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data: row, error: err } = await supabase
        .from('site_settings')
        .select('*')
        .eq('id', 1)
        .single();
      if (err) throw err;
      setData(row as SiteSettings);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load settings');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { data, loading, error, reload };
}